import { BaseQueryFn, MutationDefinition } from "@reduxjs/toolkit/dist/query";
import { MutationTrigger } from "@reduxjs/toolkit/dist/query/react/buildHooks";
import { useAppDispatch } from "./store";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { showNotification } from "../store/reducers";
import { IMessageResponse } from "../shared";

type IHandleComplete<ApiName extends string> = MutationTrigger<
  MutationDefinition<
    string,
    BaseQueryFn<
      {
        url: string;
        method: string | undefined;
        data?: any;
        params?: any;
      },
      unknown,
      unknown
    >,
    ApiName,
    IMessageResponse,
    ApiName
  >
>;
export const useHandleComplete = <ApiName extends string>(
  handleComplete: IHandleComplete<ApiName>
) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isCompleteConfirmOpen, setIsConfirmOpen] = useState(false);
  const [id, setId] = useState<string>("");

  const handleConfirmComplete = async () => {
    try {
      await handleComplete(id).unwrap();
      setIsConfirmOpen(false);
      dispatch(
        showNotification({
          type: "success",
          message: t("alert.successfulComplete"),
        })
      );
    } catch (error: any) {
      dispatch(
        showNotification({
          type: "error",
          message: t("alert.somethingWentWrong"),
        })
      );
    }
  };

  const handleCancelComplete = () => {
    setIsConfirmOpen(false);
  };

  const onComplete = (id: string) => {
    setId(id);
    setIsConfirmOpen(true);
  };

  return {
    isCompleteConfirmOpen,
    handleConfirmComplete,
    handleCancelComplete,
    onComplete,
  };
};
